import { commitmentsPayloadDataSelector } from "../commitmentsPayloadDataSelector";
import { RootState } from "@/store/store";
import { PostUsersMeOrganisationsCurrentAzureReservationsApiArg } from "@/services/cloudchipr.api";
import { commitmentsCoverageFiltersSelector } from "@/store/commitments/selectors/common/view-options/commitmentsCoverageFiltersSelector";

export const commitmentsDataGridPOSTPayloadDataSelector = (
  state: RootState,
): PostUsersMeOrganisationsCurrentAzureReservationsApiArg["body"] => {
  const payload = commitmentsPayloadDataSelector(state);
  const filters = commitmentsCoverageFiltersSelector(state);

  return {
    provider_organisation_id: payload.providerOrganisationId,
    date_from: payload.dateFrom,
    date_to: payload.dateTo,
    date_label: payload.dateLabel,
    date_type: payload.dateType,
    date_value: payload.dateValue,
    date_unit: payload.dateUnit,
    coverage_grouping: payload.coverageGrouping,
    load_table_data: payload.loadTableData,
    load_totals: false,
    load_chart_data: false,
    filter_tree: filters,
  };
};
